import _pt from "prop-types";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from 'react';

const TabButtonWithRef = _ref => {
  let children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      tabContentRef = _ref.tabContentRef,
      props = _objectWithoutProperties(_ref, ["children", "className", "tabContentRef"]);

  const Component = props.href ? 'a' : 'button';
  return React.createElement(Component, _extends({}, props, {
    className: className,
    ref: tabContentRef
  }), children);
};

TabButtonWithRef.propTypes = {
  children: _pt.node,
  className: _pt.string,
  href: _pt.string,
  tabContentRef: _pt.any
};

const withForwardedRef = Component => {
  class TabContainer extends React.Component {
    render() {
      const _this$props = this.props,
            forwardRef = _this$props.forwardRef,
            rest = _objectWithoutProperties(_this$props, ["forwardRef"]);

      return React.createElement(Component, _extends({
        ref: forwardRef
      }, rest));
    }

  }

  _defineProperty(TabContainer, "propTypes", {
    children: _pt.node,
    className: _pt.string,
    href: _pt.string,
    tabContentRef: _pt.any,
    forwardRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object])
  });

  return React.forwardRef((props, tabContentRef) => React.createElement(TabContainer, _extends({}, props, {
    forwardRef: tabContentRef
  })));
};

export const TabButton = withForwardedRef(TabButtonWithRef);